import Vue from 'vue';
import VeeValidate from 'vee-validate';
import messagesSv from '../shared/vendor/validation-locales/sv';
import messagesEs from '../shared/vendor/validation-locales/es';
import messagesMk from '../shared/vendor/validation-locales/mk';
import store from '../shared/vuex/store';
import Search from './components/Search.vue';
import 'vue2-animate/dist/vue2-animate.min.css';
import { Loading } from 'element-ui';
import { VueHammer } from 'vue2-hammer';
import FindBooking from "../search/components/FindBooking";
require('../../modules/Localization');

window.$ = window.$ || require('jquery');
window.jQuery = window.$;
window.moment = window.moment || require('moment');

Vue.use(VeeValidate, {
    locale: 'en',
    delay: 500,
    dictionary: {
        es: {
            messages: messagesEs,
        },
        mk: {
            messages: messagesMk,
        },
        sv: {
            messages: messagesSv,
        },
    },
});

Vue.use(Loading);
Vue.use(VueHammer);
Vue.component('find-booking', FindBooking);

const authenticated = window.greenmotion ? window.greenmotion.authenticated : false;

new Vue({
    el: '#search-app',
    store,
    methods: {
        refreshToken() {
            store.dispatch('refreshToken');
        },
    },
    mounted() {
        store.dispatch('setDefaultCurrency');

        if (authenticated) {
            this.refreshToken();

            setInterval(
                function () {
                    this.refreshToken();
                }.bind(this),
                180000
            );
        }
    },
    render: h => {
        return  h(Search);
    },
});
